import { Component, Input } from '@angular/core';
import { Rodeo } from '../../../../model/rodeo';
import { RodeoEvent } from '../../../../model/rodeoEvent';

@Component({
	selector: 'page-unpaid-regs',
	templateUrl: 'report-unpaid-regs.html'
	
})
export class UnpaidRegsReport {
    @Input('rodeo') rodeo: Rodeo;

    constructor() { }

    getUnpaidRegs(rodeoEvent: RodeoEvent) {
        return rodeoEvent.registrations.filter(x => (x.payConfirmation == null || x.payConfirmation == "") && x.status != 'Paid');
    }

    isRoughStock(rodeoEvent: RodeoEvent) {
        if (rodeoEvent.eventType === 'BullRiding' || rodeoEvent.eventType === 'SaddleBroncRiding' || rodeoEvent.eventType === 'RanchBroncRiding' || rodeoEvent.eventType === 'BarebackRiding')
            return true;
        else
            return false;
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/rodeo/reports/report-unpaid-regs.ts